// import React, { useEffect, useState } from "react";
// import { useForm, Controller } from "react-hook-form";
// import { HrmFormInput } from "../components/hrm_input";
// import { useNews } from "../../contexts";
// import { yupResolver } from "@hookform/resolvers/yup";
// import HrmLoader from "../components/hrm_loader";
// import { uploadImageNewsToS3 } from "../../utils/fileUpload";
// import { editNewsValidation } from "../../validations/news_validation";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";

// const AddNews = () => {
//   const {
//     handleSubmit,
//     register,
//     watch,
//     reset,
//     control,
//     formState: { errors },
//   } = useForm({
//     resolver: yupResolver(editNewsValidation),
//   });

//   const { onAddNews, newsLoader } = useNews();
//   const imageFile = watch("image");
//   const [imagePreview, setImagePreview] = useState(null);

//   useEffect(() => {
//     const file = imageFile?.[0];
//     if (file instanceof Blob) {
//       const fileReader = new FileReader();
//       fileReader.onloadend = () => {
//         setImagePreview(fileReader.result);
//       };
//       fileReader.readAsDataURL(file);
//     }
//   }, [imageFile]);

//   const onSubmit = async (values) => {
//     let s3ImageUrl = "";

//     if (values.image instanceof FileList && values.image.length > 0) {
//       const file = values.image[0];
//       s3ImageUrl = await uploadImageNewsToS3(file);
//     }

//     const payload = {
//       title: values.title,
//       description: values.description, // HTML from ReactQuill
//       image: s3ImageUrl,
//     };

//     await onAddNews(payload);
//     reset();
//     setImagePreview(null);
//   };

//   const handleReset = () => {
//     reset();
//     setImagePreview(null);
//   };

//   return (
//     <div>
//       <div className="col-span-12 md:order-1 xl:col-span-8 2xl:col-span-6">
//         <h5 className="mb-2">Add News</h5>
//       </div>
//       <div className="grid grid-cols-1 xl:grid-cols-12 gap-x-5">
//         <div className="xl:col-span-12">
//           <div className="card">
//             <div className="card-body">
//               {newsLoader ? (
//                 <HrmLoader />
//               ) : (
//                 <form onSubmit={handleSubmit(onSubmit)}>
//                   <HrmFormInput
//                     label={"Title"}
//                     placeholder={"Enter title"}
//                     error={errors?.title?.message}
//                     {...register("title")}
//                   />

//                   <div className="mb-4">
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Description
//                     </label>
//                     <Controller
//                       name="description"
//                       control={control}
//                       defaultValue=""
//                       render={({ field }) => (
//                         <ReactQuill
//                           theme="snow"
//                           value={field.value}
//                           onChange={field.onChange}
//                           className="bg-white"
//                         />
//                       )}
//                     />
//                     {errors.description && (
//                       <p className="text-red-500 text-sm mt-1">
//                         {errors.description.message}
//                       </p>
//                     )}
//                   </div>

//                   <div className="mb-4">
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Image
//                     </label>

//                     {imagePreview && (
//                       <div className="mb-2">
//                         <img
//                           src={imagePreview}
//                           alt="Preview"
//                           className="w-32 h-20 object-cover rounded"
//                         />
//                       </div>
//                     )}

//                     <input
//                       type="file"
//                       accept="image/*"
//                       {...register("image")}
//                       className="form-control"
//                     />
//                   </div>

//                   <div className="flex justify-center gap-2 mt-4">
//                     <button
//                       type="reset"
//                       className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100"
//                       onClick={handleReset}
//                     >
//                       Reset
//                     </button>
//                     <button
//                       type="submit"
//                       className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600"
//                     >
//                       Add News
//                     </button>
//                   </div>
//                 </form>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddNews;

import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { HrmFormInput } from '../components/hrm_input'
import { useNews } from '../../contexts'
import { yupResolver } from '@hookform/resolvers/yup'
import HrmLoader from '../components/hrm_loader'
import { uploadImageNewsToS3 } from '../../utils/fileUpload'
import {
  addNewsValidation,
} from '../../validations/news_validation'
import { Editor } from 'primereact/editor'
import { uploadImageViaApi, vars } from '../../common/CommonFunction'
import { toast } from 'react-toastify'

const AddNews = () => {
  const {
    handleSubmit,
    register,
    watch,
    reset,
    setValue,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(addNewsValidation)
  })

  const { onAddNews, newsLoader } = useNews()
  const imageFile = watch('image')
  const [imagePreview, setImagePreview] = useState(null)
  const [editorText, setEditorText] = useState('')
  const logoFile = watch('logo')
  const [logoPreview, setLogoPreview] = useState(null)

  useEffect(() => {
    const file = imageFile?.[0]
    if (file instanceof Blob) {
      const fileReader = new FileReader()
      fileReader.onloadend = () => {
        setImagePreview(fileReader.result)
      }
      fileReader.readAsDataURL(file)
    }
  }, [imageFile])

  useEffect(() => {
    const file = logoFile?.[0]
    if (file instanceof Blob) {
      const fileReader = new FileReader()
      fileReader.onloadend = () => {
        setLogoPreview(fileReader.result)
      }
      fileReader.readAsDataURL(file)
    }
  }, [logoFile])

  useEffect(() => {
    setValue('description', editorText)
  }, [editorText, setValue])

  const onSubmit = async values => {
    // let s3ImageUrl = ''

    // if (values.image instanceof FileList && values.image.length > 0) {
    //   const file = values.image[0]
    //   s3ImageUrl = await uploadImageNewsToS3(file)
    // }

    // let s3LogoUrl = ''

    // if (values.logo instanceof FileList && values.logo.length > 0) {
    //   const file = values.logo[0]
    //   s3LogoUrl = await uploadImageNewsToS3(file)
    // }
    let s3ImageUrl = '';
    let s3LogoUrl = '';

    // Handle image upload
    if (values.image instanceof FileList && values.image.length > 0) {
      const responseImage = await uploadImageViaApi(values.image[0], vars.folder3);

      if (responseImage?.code === 1) {
        s3ImageUrl = responseImage.data.file_name;
      } else {
        toast.error(responseImage?.message || 'Image upload failed');
        return;
      }
    }

    // Handle logo upload
    if (values.logo instanceof FileList && values.logo.length > 0) {
      const responseLogo = await uploadImageViaApi(values.logo[0], vars.folder3);

      if (responseLogo?.code === 1) {
        s3LogoUrl = responseLogo.data.file_name;
      } else {
        toast.error(responseLogo?.message || 'Logo upload failed');
        return;
      }
    }

    const payload = {
      title: values.title,
      description: editorText,
      image: s3ImageUrl,
      logo: s3LogoUrl,
      short_description: values.short_description
    }

    await onAddNews(payload)
    reset()
    setImagePreview(null)
    setEditorText('')
  }

  const handleReset = () => {
    reset()
    setImagePreview(null)
    setLogoPreview(null)
    setEditorText('')
  }

  return (
    <div>
      <div className='col-span-12 md:order-1 xl:col-span-8 2xl:col-span-6'>
        <h5 className='mb-2'>Add News</h5>
      </div>
      <div className='grid grid-cols-1 xl:grid-cols-12 gap-x-5'>
        <div className='xl:col-span-12'>
          <div className='card'>
            <div className='card-body'>
              {newsLoader ? (
                <HrmLoader />
              ) : (
                <form onSubmit={handleSubmit(onSubmit)}>
                  <HrmFormInput
                    label={'Title'}
                    placeholder={'Enter title'}
                    error={errors?.title?.message}
                    {...register('title')}
                  />

                  <HrmFormInput
                    label={'Short Description'}
                    placeholder={'Enter Short Description'}
                    error={errors?.short_description?.message}
                    {...register('short_description')}
                  />

                  <div className='mb-4'>
                    <label className='block text-sm font-medium text-gray-700 mb-1'>
                      Description
                    </label>
                    <Editor
                      value={editorText}
                      onTextChange={e => setEditorText(e.htmlValue)}
                      style={{ height: '320px' }}
                    />
                    {errors.description && (
                      <p className='text-red-500 text-sm mt-1'>
                        {errors.description.message}
                      </p>
                    )}
                  </div>

                  <div className='mb-4'>
                    <label className='block text-sm font-medium text-gray-700 mb-1'>
                      Image (size 714 x 291)
                    </label>

                    {imagePreview && (
                      <div className='mb-2'>
                        <img
                          src={imagePreview}
                          alt='Preview'
                          className='w-32 h-20 object-cover rounded'
                        />
                      </div>
                    )}

                    <input
                      type='file'
                      accept='image/*'
                      {...register('image')}
                      className='form-control'
                    />
                  </div>

                  <div className='mb-4'>
                    <label className='block text-sm font-medium text-gray-700 mb-1'>
                      Logo (size 100 x 67)
                    </label>

                    {logoPreview && (
                      <div className='mb-2'>
                        <img
                          src={logoPreview}
                          alt='Logo Preview'
                          className='w-20 h-20 object-contain rounded'
                        />
                      </div>
                    )}

                    <input
                      type='file'
                      accept='image/*'
                      {...register('logo')}
                      className='form-control'
                    />
                  </div>

                  <div className='flex justify-center gap-2 mt-4'>
                    <button
                      type='reset'
                      className='text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100'
                      onClick={handleReset}
                    >
                      Reset
                    </button>
                    <button
                      type='submit'
                      className='text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600'
                    >
                      Add News
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddNews
